/**
 * Formate une date selon le format français
 * @param {Date|string} date - La date à formater
 * @param {Object} options - Options de formatage
 * @param {boolean} options.includeTime - Inclure l'heure (défaut: true)
 * @returns {string} La date formatée
 */
export const formatDate = (date, options = { includeTime: true }) => {
  if (!date) return 'Non disponible';

  const formatOptions = {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    ...(options.includeTime && {
      hour: '2-digit',
      minute: '2-digit'
    })
  };

  return new Date(date).toLocaleString('fr-FR', formatOptions);
};

/**
 * Formate une date pour l'affichage court (JJ/MM/AAAA)
 * @param {Date|string} date - La date à formater
 * @returns {string} La date formatée
 */
export const formatShortDate = (date) => {
  if (!date) return 'Non disponible';
  return new Date(date).toLocaleDateString('fr-FR');
};

/**
 * Formate une date pour l'affichage de l'heure (HH:mm)
 * @param {Date|string} date - La date à formater
 * @returns {string} L'heure formatée
 */
export const formatTime = (date) => {
  if (!date) return 'Non disponible';
  return new Date(date).toLocaleTimeString('fr-FR', {
    hour: '2-digit',
    minute: '2-digit'
  });
}; 